// Servicio para llamar al backend local de Lip-Sync "Vortex Studio"
// (avatar + audio Kokoro → video mp4). Corre en tu PC (GPU RTX 50).
const VITE = typeof import.meta !== 'undefined' ? (import.meta.env || {}) : {};
const API_URL = (VITE.VITE_LIPSYNC_API_URL || 'http://localhost:8600').replace(/\/$/, '');
const ADMIN_TOKEN = VITE.VITE_LIPSYNC_ADMIN_TOKEN || '';

const request = async (path, options = {}) => {
  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      ...(options.isForm ? {} : { 'Content-Type': 'application/json' }),
      'X-Admin-Token': ADMIN_TOKEN,
      ...(options.headers || {}),
    },
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const data = await res.json();
      detail = data.detail || detail;
    } catch (_) { /* noop */ }
    throw new Error(detail);
  }
  return res.json();
};

// ── Estado del backend y capacidades ──
export const getLipSyncHealth = () => request('/health');

// Arranque "1 clic" del backend a través del dev server de Vite (solo dev).
export const startLipSyncServer = () => {
  const origin = (typeof window !== 'undefined' && window.location && window.location.origin) || '';
  if (!origin) return Promise.reject(new Error('Solo disponible desde el navegador en modo desarrollo.'));
  return fetch(`${origin}/__lipsync/start`, { method: 'POST' }).then((res) => res.json());
};

// ── Catálogos ──
export const getLipSyncAvatars = () => request('/api/lipsync/avatars');
export const getLipSyncAudios = () => request('/api/lipsync/audios');

// Sube una imagen custom de avatar (multipart). Devuelve {path, url, name}.
export const uploadLipSyncImage = async (file) => {
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${API_URL}/api/lipsync/upload-image`, {
    method: 'POST',
    headers: { 'X-Admin-Token': ADMIN_TOKEN },
    body: form,
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try { const d = await res.json(); detail = d.detail || detail; } catch (_) { /* noop */ }
    throw new Error(detail);
  }
  return res.json();
};

// ── Generar video (asíncrono, por tareas con progreso) ──
export const startLipSyncGeneration = (payload) =>
  request('/api/lipsync/generate', { method: 'POST', body: JSON.stringify(payload) });

export const getLipSyncTask = (taskId) => request(`/api/lipsync/task/${encodeURIComponent(taskId)}`);

export const cancelLipSyncTask = (taskId) =>
  request(`/api/lipsync/cancel/${encodeURIComponent(taskId)}`, { method: 'POST' });

// URL con token del archivo de video guardado.
export const lipSyncFileUrl = (path) => {
  const params = new URLSearchParams({ path });
  return `${API_URL}/api/lipsync/file?${params.toString()}`;
};